import React, { Component, Fragment } from 'react';
import { compose } from '../../reactApolloCompat';
import { withRouter } from '../../util/withRouter';
import { withSnackbarMessage } from '../../context/SnackbarMessage';
import withStyles from '@mui/styles/withStyles';
import Typography from '../../component/Typography';
import Grid from '../../component/form/Grid';
import Paper from '@mui/material/Paper';
import gql from 'graphql-tag';
import GraphqlGrid from '../../component/form/v2/GraphqlGrid';
import { withErrorBoundary } from '@sentry/react';
import ErrorFallback from '../../component/ErrorFallback';
import { prettyPrice } from '../../util/strings';
import { shortDateFromString } from '../../util/date';
import LinkButton from '../../component/form/LinkButton';
import { Invoice } from '../fragments/Invoices';
import { getClient } from '../../apollo';
import InvoiceModal from '../funeral/billing/invoiceModal/InvoiceModal';
import { createForm } from '../../util/form';
import { getOfficeFromKey } from '../../util/brands';
import BrandDot from '../../component/table/BrandDot';

class Invoices extends Component {
    listQuery = gql`
        query paymentsQuery(
            $limit: Int
            $offset: Int
            $filter: SalesRegisterFilterFields
            $sort: SalesRegisterSortFields
        ) {
            readSalesRegisters(limit: $limit, offset: $offset, filter: $filter, sort: $sort) {
                edges {
                    node {
                        ID
                        Created
                        XeroReference
                        LegacyKey
                        TransType
                        InvoiceNo
                        Nett
                        TransDate
                        Invoice {
                            ID
                            Hena
                            IsPurchase
                            FuneralID
                        }
                    }
                }
                pageInfo {
                    totalCount
                    hasNextPage
                    hasPreviousPage
                }
            }
        }
    `;

    itemQuery = gql`
        ${Invoice}
        query readOneInvoiceQuery($id: ID!) {
            readOneInvoice(ID: $id) {
                ...InvoiceObject
            }
        }
    `;

    state = {
        invoiceID: null
    };

    form = createForm(this, { Invoices: [] });

    render() {
        const { classes } = this.props;
        const { invoiceID } = this.state;

        const listColumns = [
            {
                name: 'Link',
                queryField: 'node.ID',
                hidden: true,
                render: (val, { node }) => `/funeral/${node.Invoice.Hena}/${node.Invoice.FuneralID}`
            },
            {
                name: 'Invoice/Bill ID',
                queryField: 'node.Invoice.ID',
                gqlFilterOperation: 'eq',
                gqlFilterField: 'InvoiceID',
                gqlSortField: 'InvoiceID',
                noWrap: true,
                hidden: false,
                render: val => <>#{val}</>
            },
            {
                name: 'Funeral Key',
                queryField: 'node.Invoice.Hena',
                gqlFilterField: 'Invoice.Hena',
                gqlSortField: 'Invoice.Hena',
                noWrap: true,
                render: (val, { node }) => {
                    const { color } = getOfficeFromKey(val);
                    return (
                        !!val && (
                            <LinkButton
                                href={node.Invoice.FuneralID > 0 ? `/funeral/${val}/${node.Invoice.FuneralID}` : null}
                            >
                                <BrandDot dotColour={color} />
                                <span style={{ marginLeft: 8 }}>{val}</span>
                            </LinkButton>
                        )
                    );
                }
            },
            {
                name: 'Xero Ref',
                queryField: 'node.XeroReference',
                gqlFilterField: 'XeroReference',
                gqlSortField: 'XeroReference',
                noWrap: true
                // render: (val, { node }) => {}
            },
            {
                name: 'Paid Date',
                queryField: 'node.TransDate',
                gqlFilterField: 'TransDate',
                gqlSortField: 'TransDate',
                noWrap: true,
                render: val => shortDateFromString(val)
            },
            {
                name: 'Amount',
                queryField: 'node.Nett',
                gqlFilterNumber: true,
                gqlFilterOperation: 'eq',
                gqlFilterField: 'Nett',
                gqlSortField: 'Nett',
                noWrap: true,
                render: (val, { node }) => (node.Invoice.IsPurchase ? prettyPrice(-val) : prettyPrice(val))
            },
            {
                name: 'Cashflow',
                queryField: 'node.Invoice.IsPurchase',
                gqlSortField: 'Invoice.IsPurchase',
                gqlFilterField: 'Invoice.IsPurchase',
                gqlFilterOptions: [
                    { label: 'Payments', value: true },
                    { label: 'Receipt', value: false }
                ],
                gqlFilterOperation: 'eq',
                noWrap: true,
                render: (val, { node }) => (node.Invoice.IsPurchase ? 'Payment' : 'Receipt')
            }
        ];

        return (
            <Fragment>
                <Typography variant="display4" gutterBottom className={classes.pageTitle}>
                    <span>Financial</span>
                    <small className={classes.header}>Transactions</small>
                </Typography>
                <>
                    <div>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <GraphqlGrid
                                    hideSearch
                                    columns={listColumns}
                                    noResultsMessage={
                                        <Typography>
                                            No items matched your search.
                                            <br />
                                            <small>Try different keywords or filters.</small>
                                        </Typography>
                                    }
                                    gqlDefaultMode
                                    gqlReadQuery={this.listQuery}
                                    gqlQueryVariables={{
                                        sort: { Created: 'DESC' }
                                    }}
                                    gqlReadDataSelector={'readSalesRegisters.edges'}
                                    gqlReadPageInfoSelector={'readSalesRegisters.pageInfo'}
                                    gqlPageSizes={[5, 10, 25, 50]}
                                    onRowClick={(evt, { node }) => {
                                        evt.preventDefault();
                                        getClient()
                                            .query({
                                                query: this.itemQuery,
                                                variables: { id: node.Invoice.ID }
                                            })
                                            .then(({ data }) => {
                                                if (data && data.readOneInvoice) {
                                                    this.form.setState({ Invoices: [data.readOneInvoice] });
                                                    this.setState({ invoiceID: data.readOneInvoice.ID });
                                                }
                                            });
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </div>
                </>

                <InvoiceModal
                    onClose={() => this.setState({ invoiceID: null })}
                    open={!!invoiceID}
                    //onSubmit={e => this.onSubmitNewInvoice(e)}
                    form={this.form}
                    invoiceIndex={0}
                />
            </Fragment>
        );
    }
}

const styles = ({ spacing, breakpoints, palette, funeralHome, typography }) => ({
    paper: {
        padding: `${spacing(2)} ${spacing(5)}`,
        [breakpoints.down('md')]: {
            padding: spacing(2)
        }
    },
    pageTitle: {
        color: palette.contentForeground[funeralHome]
    },
    header: {
        fontWeight: typography.fontWeightLight,
        marginLeft: 16,
        paddingLeft: 16,
        borderLeft: '1px solid ' + palette.action.active,
        color: palette.text.primary
    },
    isGood: {
        color: palette.validation.good
    },
    isBad: {
        color: palette.validation.error
    }
});

export default withErrorBoundary(compose(withRouter, withSnackbarMessage, withStyles(styles))(Invoices), {
    fallback: ErrorFallback
});
